import PropTypes from 'prop-types'
import {
  progressBarColorOptions,
  progressBarSizeOptions,
  progressBarVariantOptions
} from '../constants'
import { ProgressBarLabelItem } from '../styled-components'

const ProgressBarLabel = ({
  variant = progressBarVariantOptions.PRIMARY,
  labelColor = null,
  customLabelStyle = null,
  size = progressBarSizeOptions.SMALL,
  children
}) => {
  const defineColor = labelColor ?? progressBarColorOptions[variant]

  return (
    <ProgressBarLabelItem
      color={defineColor}
      size={size}
      style={customLabelStyle}
    >
      {children}
    </ProgressBarLabelItem>
  )
}

ProgressBarLabel.propTypes = {
  labelColor: PropTypes.string,
  customLabelStyle: PropTypes.object,
  size: PropTypes.oneOf(Object.values(progressBarSizeOptions)),
  children: PropTypes.node
}

export default ProgressBarLabel
